import { SubCampaignFeedback, Validations } from '@/types';
import { validateField } from './campaignValidations';
import { CR_TYPE, qmbApprover } from './constants';

export const validateFeedbackForm = (validations: Validations, subCampaign: any) => {
  const feedbackFields = [];
  const feedbackApprovers = subCampaign.subCampaignInfo.type === CR_TYPE.CAR ? [qmbApprover] : [];

  let feedbackValidation: Validations = {};//
  const { feedback } = subCampaign;

  feedbackApprovers.forEach((approver) => {
    const value = feedback?.approvers[approver]?.code;
    feedbackValidation[approver] = validateField(validations, value, { required: true });
  });

  feedbackFields.forEach((field) => {
    const value = feedback?.[field];
    // @ts-ignore
    feedbackValidation[field] = validateField(validations, value, { required: true });
  });

  feedbackValidation = validateCampaignsOfSubCampaign(feedback, feedbackValidation);
  feedbackValidation.invalid = Object.values(feedbackValidation).some((field) => field?.invalid);

  return feedbackValidation;
};

const validateCampaignsOfSubCampaign = (feedback: SubCampaignFeedback, campaignValidation) => {
  const { campaigns } = feedback;

  campaignValidation['campaigns'] = {};

  campaigns.forEach((campaign, index) => {
    campaignValidation.campaigns[index] = {
      campaignNumber: validateCampaignNumber(campaign.campaignManagerEntry.campaignNumber, feedback, campaignValidation),
    }
    campaignValidation.campaigns[index].invalid = Object.values(campaignValidation.campaigns[index]).some((field) => field?.invalid);
  });

  campaignValidation.campaigns.invalid = Object.values(campaignValidation.campaigns).some((field) => field?.invalid);

  return campaignValidation;
}

const validateCampaignNumber = (campaignNumber: string, feedback: SubCampaignFeedback, validations) => {
  const { campaigns } = feedback;
  const campaignNumbers = campaigns.map((campaign) => campaign.campaignManagerEntry.campaignNumber);
  const campaignsTotal = campaignNumbers.length;
  const duplicates = campaignNumbers.filter((number) => number === campaignNumber);
  const duplicate = duplicates.length > 1;
  const validation = validateField(
    validations, 
    campaignNumber, 
    (campaignsTotal > 1  || (campaignsTotal === 1 && campaignNumber !== '')) ? { required: true, max: 12, min: 12 } : {},
    true
  );

  return { 
    ...validation,
    errors: {
      ...validation.errors,
      duplicate: duplicate,
    },
    invalid: validation.invalid || duplicate };
}

export default validateFeedbackForm;
